import { Component, OnInit, Output } from '@angular/core';
import { OrgviewService } from './service/orgview.service';
import { Router, ActivatedRoute } from '@angular/router';
import { Organization } from './model/Organization';

import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';

@UntilDestroy({ checkProperties: true })
@Component({
  selector: 'app-orgview',
  templateUrl: './orgview.component.html',
  styleUrls: ['./orgview.component.css']
})
export class OrgviewComponent implements OnInit {
  @Output() org:Organization;
  constructor(
    private orgsrv:OrgviewService,
    private router:Router,
    private route:ActivatedRoute,
    ) { }

  ngOnInit() {
    this.org ={
      organizationId: "",
    organizationname: "",
      orgdesc: "",
      www: "",
      email:"",
      address: "",
      address2: "",
      zip: "",
      city: "",
      country: "",
      logourl: ""
    }
    this.orgsrv.getOrg(this.route.snapshot.paramMap.get('organizationId')).pipe(untilDestroyed(this)).subscribe(org => {
      this.org = org;
    },(error)=>{
      alert('ERROR: '+error.error);
    });

  }

}
